import React,{ useEffect, useContext, useState } from 'react'
import Moment from 'react-moment';
import 'moment-timezone';
import AddPass from '../modal/addpassword'
import Swal from 'sweetalert2'
import Images from '../../img'
import { store } from '../../store';
import { PASSLIST_UPDATE, PASSLIST_ADD } from '../../store/constants'
import './style.css'
import { Link, useHistory } from 'react-router-dom'
import { FireRemovePass, FireFetchData } from '../../hooks/firebaseFirestore'

function Table() {
    const firestoreFetchPass = FireFetchData()
    const firestoreRemovePass = FireRemovePass()
    const history = useHistory()
    const { state, dispatch } = useContext(store)
    const { collections, searchCollection, loading, status } = state.passwordManagement
    const { email } = state.user
    const [ eyePass,setEye ] = useState('password')

    useEffect(()=>{        
        if (loading) {
            Swal.showLoading()
        } else {
            Swal.close()
        }
    },[loading])

    useEffect(()=>{
        dispatch({
            type: "PASSLIST_LOADING",
            status: true
        })
        fetchPass()
        // eslint-disable-next-line
    },[])

    const passEyeHandle = () => {
        eyePass === 'password' ? setEye('text') : setEye('password')
    }
    
    const fetchPass = () => {
        let emailTemp;
        email ? emailTemp = email : emailTemp = localStorage.getItem('account')
        if (localStorage.getItem('account')) {
            firestoreFetchPass(emailTemp)
        } else if (!localStorage.getItem('account') && !emailTemp) {
            firestoreFetchPass('test@mail.com')
            history.push('/')
        }
    }

    const handleAdd = (e) => {
        if (status === 'add') {
            e.preventDefault()
            dispatch({
                type: PASSLIST_ADD
            })
        }
    }

    const searchVal = e => {
        if (e.target.value) {
            dispatch({
                type: "PASSLIST_LOADING",
                status: true
            })
            const collection = collections.filter(pass=>{
                return pass.url.toLowerCase().includes(e.target.value.toLowerCase())
            })
            dispatch({
                type: 'PASSLIST_SEARCH',
                listSearch: collection
            })
            dispatch({
                type: "PASSLIST_LOADING",
                status: false
            })
        } else {
            dispatch({
                type: "PASSLIST_LOADING",
                status: true
            })
            fetchPass()
        }
    }

    const updatePw = (e,id) => {
        e.preventDefault()
        let pass = collections.filter( pass =>{
            return pass.id === id
        })
        dispatch({
            type: PASSLIST_UPDATE,
            pass
        })
    }

    const fireDeletePass = (e,id) => {
        e.preventDefault()
        dispatch({
            type: "PASSLIST_LOADING",
            status: true
        })
        let updatefix = []
        collections.forEach(pass=>{
            if (pass.id !== id) {
                updatefix.push(pass)
            }
        })
        let emailTemp;
        email ? emailTemp = email : emailTemp = localStorage.getItem('account')
        firestoreRemovePass(updatefix, emailTemp)
            .then(_ => {})
            .catch(err => { console.log(err) })
    }

    return (
        <div className="container mt-5">
            <div className="row">
                <div data-testid="addPass-test" onClick={ event => handleAdd(event) }>
                    <AddPass
                        className="mr-auto mb-1 ml-5"
                        action="add"
                    ></AddPass>
                </div>
                <div className="input-group mb-1 ml-auto mr-3" style={{ width: '30rem' }}>
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                            <i className="fas fa-search"></i>
                        </span>
                    </div>
                    <input data-testid="input-search-test" type="text" className="form-control" placeholder="Search By Url.." onChange={ searchVal } aria-label="Username" aria-describedby="basic-addon1"/>
                </div>
            </div>
            <table data-testid="table-test" className="table table-dark">
                <thead>
                    <tr>
                        <th scope="col" >Url</th>
                        <th scope="col">Username</th>
                        <th scope="col">
                            Password
                            {
                                eyePass === 'password' ? 
                                <i className="fas fa-eye ml-2" data-testid="eyePassTrue-test" onClick={ passEyeHandle }></i>
                                :
                                <i className="fas fa-eye-slash ml-2 mt-1" data-testid="eyePassFalse-test" onClick={ passEyeHandle }></i>
                            }
                        </th>
                        <th scope="col">CreatedAt</th>
                        <th scope="col">UpdatedAt</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !searchCollection ? 
                        collections.length === 0 ? <tr></tr> :
                        collections.map((collection)=>{
                            return (
                                <tr key={ collection.id }>
                                    <td>
                                        <Link to="/manage" className="urlstyle"> { collection.url } </Link></td>
                                    <td>{ collection.username }</td>
                                    {
                                        eyePass === 'password' ?
                                        <td className="d-flex flex-row justify-content-center">
                                            {
                                                collection.password.split('').map((char,index)=>{
                                                    return(
                                                        <div key={ index }>
                                                            <i className="fas fa-dot-circle pr-1" style={{ fontSize: '7px' }}></i>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </td>
                                        :
                                        <td>
                                            { collection.password }
                                        </td>
                                    }
                                    <td>
                                        <Moment format="D MMMM YYYY">
                                            { collection.createAt }
                                        </Moment>
                                    </td>
                                    <td>
                                        {
                                            collection.updatedAt ?
                                            <Moment format="D MMMM YYYY">
                                                { collection.updateAt }
                                            </Moment>
                                            :
                                            <h6 style={{ color: "#d1d1d1" }}> not Updated </h6>
                                        }
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-center">
                                            <div onClick={ event => updatePw(event,collection.id) }>
                                                <AddPass
                                                    action="update"
                                                />
                                            </div>
                                            <button data-testid="removePass-test" onClick={ event => fireDeletePass(event, collection.id) } type="button" className="ml-2 btn btn-light btn-sm px-2">
                                                <i className="fas fa-trash" style={{ color: "red" }}></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                        :
                        searchCollection.length === 0 ? <tr></tr> :
                        searchCollection.map((collection)=>{
                            return (
                                <tr key={ collection.id }>
                                    <td>
                                        <Link to="" className="urlstyle"> { collection.url } </Link></td>
                                    <td>{ collection.username }</td>
                                    {
                                        eyePass === 'password' ?
                                        <td className="d-flex flex-row justify-content-center">
                                            {
                                                collection.password.split('').map((char,index)=>{
                                                    return(
                                                        <div key={ index }>
                                                            <i className="fas fa-dot-circle pr-1" style={{ fontSize: '7px' }}></i>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </td>
                                        :
                                        <td>
                                            { collection.password }
                                        </td>
                                    }
                                    <td>
                                        <Moment format="D MMMM YYYY">
                                            { collection.createAt }
                                        </Moment>
                                    </td>
                                    <td>
                                        {
                                            collection.updatedAt ?
                                            <Moment format="D MMMM YYYY">
                                                { collection.updateAt }
                                            </Moment>
                                            :
                                            <h6 style={{ color: "#d1d1d1" }}> not Updated </h6>
                                        }
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-center">
                                            <div data-testid="updatePass-test" onClick={ event => updatePw(event,collection.id) }>
                                                <AddPass
                                                    action="update"
                                                />
                                            </div>
                                            <button data-testid="removePass-test" onClick={ event => fireDeletePass(event, collection.id) } type="button" className="ml-2 btn btn-light btn-sm px-2">
                                                <i className="fas fa-trash" style={{ color: "red" }}></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            {
                collections.length === 0 &&
                <img data-testid="notfound-test" src={ Images.noresult } alt="notfound"/>
            }
            {
                searchCollection.length === 0 && collections.length !== 0 &&
                <img data-testid="notfoundSearch-test" src={ Images.noresult } alt="notfound"/>
            }
        </div>
    )
}

export default Table